import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/site/Logo";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate(location.state?.from?.pathname || "/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-forest-800 px-6">
      <div className="relative z-10 w-full max-w-md">
        <div className="mb-8 flex justify-center">
          <Logo light />
        </div>
        <form
          onSubmit={submit}
          className="rounded-xl border border-bone/15 bg-white p-8 shadow-2xl shadow-forest-900/50"
          data-testid="admin-login-form"
        >
          <h1 className="font-display text-2xl font-extrabold text-forest-700">Team login</h1>
          <p className="mt-1 text-sm text-moss">Melwest staff only.</p>
          <div className="mt-6 space-y-4">
            <div>
              <label className="mb-1.5 block text-xs font-bold uppercase tracking-[0.12em] text-forest-700" htmlFor="a-email">Email</label>
              <Input id="a-email" type="email" required className="h-11 border-forest-700/20 focus-visible:ring-terra" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
            </div>
            <div>
              <label className="mb-1.5 block text-xs font-bold uppercase tracking-[0.12em] text-forest-700" htmlFor="a-password">Password</label>
              <Input id="a-password" type="password" required className="h-11 border-forest-700/20 focus-visible:ring-terra" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
            </div>
          </div>
          {error && (
            <p className="mt-4 rounded-md bg-red-50 px-3 py-2 text-sm font-semibold text-red-600" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <Button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="mt-6 inline-flex h-12 w-full items-center justify-center gap-2 rounded-full bg-terra text-sm font-bold text-bone hover:bg-terra-dark"
          >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
